import React, {useState, useCallback, useRef} from "react";
import {useDropzone} from "react-dropzone";
import {useForm} from "react-hook-form";
import {Bars} from "react-loader-spinner";

import {apollo_useStyles} from "../../../atom/Apollo_styles";
import {ApolloBasicLabel} from "../../../molecule/Apollo_BaseItem";
import {ApolloMessage, CustomizedSnackbars} from "../../../atom/Apollo_Mesasge";
import {CrAssetZipZeus} from "./CrAssetModel";

import Backdrop from "@material-ui/core/Backdrop";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card/Card";
import CardActions from "@material-ui/core/CardActions/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Check from"@material-ui/icons/Check"
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

type ZeusCrAssetZipFormProps = {
  crAssetZipState: {
    crAsset: CrAssetZipZeus,
    setCrAsset: any,
  },
  uploadedMsgState: {
    uploadedMsg: string,
    setUploadedMsg: any,
  },
  downloadAction: any,
  submitAction: any,
  goBackAction: any,
}

const fileMaxSize: number = 20;

const CrAssetZipFormZeus = ({crAssetZipState, uploadedMsgState, downloadAction, submitAction, goBackAction}: ZeusCrAssetZipFormProps) => {
  const classes = apollo_useStyles();
  const processing = useRef(false);
  const [bdopen, setbdOpen] = React.useState(false);
  const {data, setmsg} = React.useContext(ApolloMessage);

  const {control, formState, handleSubmit, register} = useForm({mode: "onBlur", reValidateMode: "onBlur"});

  const reader = new FileReader();

  // 編集時ローディング
  const bdhandleToggle = () => {
    setbdOpen(!bdopen);
  };
  const bdhandleClose = () => {
    setbdOpen(false);
  };

  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    uploadedMsgState.setUploadedMsg("")

    if (fileRejections[0]?.errors[0].code == 'file-invalid-type') {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "ZIPファイルのアップロードに失敗しました。ファイルの拡張子を確認してください。"
        }
      });
      return
    }

    if (fileRejections[0]?.errors[0].code == 'file-too-large') {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "ZIPファイルのアップロードに失敗しました。ZIPファイルのサイズを確認してください。"
        }
      });
      return
    }

    if (!acceptedFiles || !acceptedFiles[0]) {
      crAssetZipState.setCrAsset({
        attachment: "",
      });

      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "ZIPファイルのアップロードに失敗しました。"
        }
      });
      return
    }

    crAssetZipState.setCrAsset({
      attachment: acceptedFiles,
    });
    reader.readAsDataURL(acceptedFiles[0]);
  }, []);

  const {acceptedFiles, getRootProps, getInputProps} = useDropzone({
    accept: '.zip',
    maxSize: 1024*1024*fileMaxSize,
    onDrop,
    multiple: false,
  });

  // // @ts-ignore
  // const files = acceptedFiles.map(file => (
  //   file.name
  // ));

  const onSubmit = handleSubmit(async () => {
    if (processing.current) return;
    if (formState.isSubmitting) return;

    bdhandleToggle();
    await submitAction();
    bdhandleClose();
  });

  return (
    <React.Fragment>
      <CustomizedSnackbars/>

      <Backdrop className={classes.backdrop} open={bdopen}>
        <Bars color="#00BFFF" height={80} width={80}/>
      </Backdrop>

      <Card className={classes.root} square variant="outlined">
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <ApolloBasicLabel label={"メニュー"} value={"パフォーマンス広告"}/>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom component="div" color="inherit">
                アップロードファイル
              </Typography>
              <Typography variant="body2" gutterBottom component="div" color="textSecondary">
                【サイズ】最大{fileMaxSize}MB<br />
                【ファイル形式】ZIP形式（画像ファイルはpng, jpeg, gif）<br />
                <div style={{ fontFamily: "monospace", whiteSpace: "pre-wrap" }}>
                  【幅:高さ】
                  <span>
                    アップロードする画像は、入稿可能な画像サイズの条件を満たす必要があります。
                  </span>
                </div>
                <div style={{ marginLeft: "80px" }}>
                  入稿可能な画像サイズの詳細は
                  <a
                    href={process.env.REACT_APP_MANAGEMENT_MANUAL_AD_IMAGE}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    管理画面マニュアル
                  </a>
                  をご確認ください
                </div>
                ※ZIPファイル作成時、画像ファイルをフォルダにまとめずに直接圧縮してください。<br />
              </Typography>
              <section className="container">
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <div className={classes.droparea}>
                    <p className={classes.p}>ここにファイルをドラッグ＆ドロップ<br/>もしくは、クリックして選択</p>
                  </div>
                </div>
                <ul id="file1">
                  {crAssetZipState.crAsset.attachment
                    ? <li>{crAssetZipState.crAsset.attachment[0].name}</li>
                    : undefined}
                </ul>
              </section>
            </Grid>
            {
              uploadedMsgState.uploadedMsg
                ? <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom component="div" color="inherit">
                    アップロード結果
                  </Typography>
                    <Typography variant="body2" component="div" color="textSecondary" style={{marginLeft: "15px"}}>
                      {uploadedMsgState.uploadedMsg}<Check style={{color: "#2DBE60"}} viewBox="-5 -5 24 24"></Check>
                  </Typography>
                  <Typography variant="button" gutterBottom component="div">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={downloadAction}
                      className={classes.button}
                    >
                      アップロード結果ダウンロード
                    </Button>
                  </Typography>
                </Grid>
                : undefined
            }
          </Grid>
        </CardContent>
        <CardActions>
          <Button
            type="submit"
            color="primary"
            className={classes.button}
            onClick={onSubmit}
            variant="contained"
            disabled={
              crAssetZipState.crAsset.attachment === ""
              || processing.current
              || formState.isSubmitting
            }
          >
            アップロード
          </Button>
          <Button
            variant="contained"
            color="inherit"
            onClick={goBackAction}
            className={classes.button}
            disabled={processing.current}
          >
            キャンセル
          </Button>

        </CardActions>
      </Card>
    </React.Fragment>
  );
}
export default CrAssetZipFormZeus;
